enum TableInputTypes {
  Select = 'select',
  Input = 'input',
  Checkbox = 'checkbox',
}

export default TableInputTypes;
